const menuData = [
  {
    icon: 'el-icon-s-check',
    name: '审批管理',
    url: '/',
    id: 3,
    children: [
      {
        icon: 'icon-tongji',
        name: '审批统计',
        url: '/approveManage/approveCount',
        id: 36,
      },
      {
        icon: 'icon-yuyueguanli',
        name: '预约管理',
        url: '/approveManage/fellLicenceApply',
        id: 31,
      },
      {
        icon: 'icon-caifazheng',
        name: '采伐证审批',
        url: '/approveManage/fellLicenceApprove',
        id: 32,
      },
      {
        icon: 'icon-yuyueguanli',
        name: '用火审批',
        url: '/approveManage/useFireApprove',
        id: 33,
      },
      {
        icon: 'icon-yonghu',
        name: '采伐者审核',
        url: '/approveManage/fellerApprove',
        id: 34,
      },
      {
        icon: 'icon-gongchang',
        name: '集材厂/加工厂审核',
        url: '/approveManage/factoryApprove',
        id: 35,
      },
    ],
  },
  {
    icon: 'el-icon-orange',
    name: '林木管理',
    url: '/',
    id: 1,
    children: [
      {
        icon: 'icon-liebiao',
        name: '伐区列表',
        url: '/fell/fellAreaManage',
        id: 12,
      },
      {
        icon: 'icon-xiaoshou',
        name: '林木销售',
        url: '/fell/fellAreaSale',
        id: 13,
      },
      {
        icon: 'icon-ruku',
        name: '经营入库台帐',
        url: '/fell/incomingAccount',
        id: 22,
      },
      {
        icon: 'icon-chuku',
        name: '经营出库台账',
        url: '/fell/outboundAccount',
        id: 23,
      },
    ],
  },
  {
    icon: 'el-icon-tickets',
    name: '巡护执法',
    url: '/',
    id: 7,
    children: [
      {
        icon: 'icon-tongji',
        name: '巡护统计',
        url: '/patrolManagement/patrolCount',
        id: 74,
      },
      {
        icon: 'icon-xunhujilu',
        name: '巡护记录',
        url: '/messageManage/patrol',
        id: 72,
      },
      {
        icon: 'icon-shijianguanli',
        name: '事件管理',
        url: '/messageManage/eventManage',
        id: 41,
      },
      // {
      // 	icon: 'icon-duchazhifaguanli',
      // 	name: '执法管理',
      // 	url: '/patrolManagement/iawEnforcingManagement',
      // 	id:73
      // },
      // {
      // 	icon: 'icon-hangzhengchufa',
      // 	name: '处罚记录',
      // 	url: '/messageManage/punishRecord',
      // 	id: 43
      // },
      {
        icon: 'icon-renyuanguanli',
        name: '人员管理',
        url: '/patrolManagement/peopleManagement',
        id: 71,
      },
    ],
  },
  {
    icon: 'el-icon-s-custom',
    name: '林长任务',
    url: '/',
    id: 8,
    children: [
      {
        icon: 'icon-tongji',
        name: '林长统计',
        url: '/forestManage/foresterCount',
        id: 84,
      },
      {
        icon: 'icon-renwu',
        name: '任务平台',
        url: '/forestManage/missionPlatform',
        id: 82,
      },
      {
        icon: 'icon-renyuanguanli',
        name: '人员管理',
        url: '/forestManage/person',
        id: 81,
      },
      {
        icon: 'icon-xunhujilu',
        name: '林长巡护',
        url: '/forestManage/foresterPatrol',
        id: 83,
      },
    ],
  },
  {
    icon: 'el-icon-s-custom',
    name: '核查任务',
    url: '/',
    id: 9,
    children: [
      {
        icon: 'icon-tongji',
        name: '核查统计',
        url: '/vectorTaskManage/vectorTaskCount',
        id: 93,
      },{
        icon: 'icon-renyuanguanli',
        name: '人员管理',
        url: '/vectorTaskManage/vectorTaskUserManage',
        id: 91,
      },
      {
        icon: 'icon-renwu',
        name: '任务平台',
        url: '/vectorTaskManage/vectorTaskPlatform',
        id: 92,
      },
     
    ],
  },
  {
    icon: 'el-icon-map-location',
    name: '一张图',
    url: '/',
    id: 5,
    children: [
      // {
      // 	name: '公开图层',
      // 	url: '/coverageManage/publicCoverage',
      // 	id:51
      // },
      {
        icon: 'icon-ditu',
        name: '一张图',
        url: '/coverageManage/oneMap',
        id: 56,
      },
      // {
      // 	icon: 'icon-ditu1',
      // 	name: '地图列表',
      // 	url: '/coverageManage/shareCoverage',
      // 	id: 52
      // },
      {
        icon: 'icon-dituguanli',
        name: '地图管理',
        url: '/userManage/map',
        id: 55,
      },
      {
        icon: 'icon-shuju',
        name: '数据管理',
        url: '/coverageManage/dataManage',
        id: 53,
      },
      {
        icon: 'icon-zubie',
        name: '组别管理',
        url: '/coverageManage/ShareGroup',
        id: 59,
      },
      {
        icon: 'icon-dianziditu',
        name: '电子地图',
        url: '/coverageManage/eMap',
        id: 54,
      },
      {
        icon: 'icon-xiazai',
        name: '数据下载',
        url: '/coverageManage/dataDownload',
        id: 51,
      },
      // {
      // 	icon: 'icon-shangbao',
      // 	name: '上报图层',
      // 	url: '/coverageManage/reportCoverage',
      // 	id: 53
      // }, {
      // 	icon: 'icon-caifazheng',
      // 	name: '采伐证申请图层',
      // 	url: '/coverageManage/fellLicenceApplyCoverage',
      // 	id: 54
      // },
    ],
  },
  {
    icon: 'el-icon-message',
    name: '信息管理',
    url: '/',
    id: 4,
    children: [
      {
        icon: 'icon-yonghu',
        name: '采伐者',
        url: '/messageManage/operator',
        id: 11,
      },
      {
        icon: 'icon-gongchang',
        name: '集材厂/加工厂',
        url: '/messageManage/facs',
        id: 21,
      },
      // {
      // 	name: '打卡管理',
      // 	url: '/messageManage/patrol',
      // 	id:44
      // },
      {
        icon: 'icon-shangbao',
        name: '上报管理',
        url: '/messageManage/reportManage',
        id: 45,
      },
      {
        icon: 'icon-gonggao',
        name: '公告管理',
        url: '/messageManage/noticeManage',
        id: 46,
      },
      {
        icon: 'icon-xingzheng',
        name: '行政通知',
        url: '/messageManage/punish',
        id: 43,
      },
      {
        icon: 'el-icon-s-order',
        name: '审批预设',
        url: '/messageManage/defaultText',
        id: 47,
      },
    ],
  },

  {
    icon: 'el-icon-setting',
    name: '平台管理',
    url: '/',
    id: 6,
    children: [
      {
        icon: 'icon-renyuanguanli',
        name: '用户管理',
        url: '/userManage/ordinaryUser',
        id: 61,
      },
      {
        icon: 'icon-dagongren',
        name: '工作人员',
        url: '/userManage/worker',
        id: 62,
      },
      {
        icon: 'icon-jiaoseguanli',
        name: '角色管理',
        url: '/userManage/role',
        id: 63,
      },
      {
        icon: 'icon-liuchengsheji',
        name: '流程设计',
        url: '/userManage/process',
        id: 64,
      },
      {
        icon: 'icon-layer',
        name: '图层管理',
        url: '/userManage/coverageManage',
        id: 67,
      },
      {
        icon: 'icon-quyuguanli',
        name: '区域管理',
        url: '/userManage/areaManage',
        id: 65,
      },
      {
        icon: 'icon-tuisong',
        name: '推送管理',
        url: '/userManage/pushManage',
        id: 68,
      },
      {
        icon: 'icon-apps',
        name: 'APP版本管理',
        url: '/userManage/app',
        id: 66,
      },
      {
        icon: 'icon-rizhi',
        name: '日志管理',
        url: '/userManage/logManage',
        id: 42,
      },
    ],
  },
]
const menuData2 = [
  {
    icon: 'el-icon-postcard',
    name: '信息管理',
    url: '/',
    id: 1,
    children: [
      {
        icon: 'icon-liebiao',
        name: '伐区管理',
        url: '/infoManage/fellAreaManage',
        id: 11,
      },
      {
        icon: 'icon-yuyueguanli',
        name: '我的预约',
        url: '/infoManage/reserveManage',
        id: 12,
      },
      {
        icon: 'icon-liuchengsheji',
        name: '设计管理',
        url: '/infoManage/designManage',
        id: 13,
      },
      {
        icon: 'icon-ruku',
        name: '入库管理',
        url: '/infoManage/incomingManage',
        id: 14,
      },
      {
        icon: 'icon-chuku',
        name: '出库管理',
        url: '/infoManage/outingManage',
        id: 15,
      },
      {
        icon: 'icon-xiaoshou',
        name: '林木销售',
        url: '/infoManage/fellAreaSaleManage',
        id: 16,
      },
      {
        icon: 'icon-caifazheng',
        name: '我的申请',
        url: '/infoManage/approveManage',
        id: 17,
      },
      {
        icon: 'icon-yonghu',
        name: '采伐者',
        url: '/userCenter2/feller',
        id: 18,
      },
      {
        icon: 'icon-gongchang',
        name: '加工厂/集材厂',
        url: '/userCenter2/factories',
        id: 19,
      },
      {
        icon: 'icon-gonggao',
        name: '公告',
        url: '/userCenter2/noticeManage',
        id: 31,
      },
    ],
  },
]

export { menuData, menuData2 }
